import { IconSearch, IconSearchFilled, IconX } from '@tabler/icons-react';

export default function Busqueda({ value = '', onChange, size = 'md', placeholder }) {
  const isLarge = size === 'lg';
  const hint = placeholder || (isLarge ? 'Buscar cliente o pedido' : 'Buscar...');

  if (isLarge) {
    return (
      <div className="relative w-full" style={{ height: '48px' }}>
        <IconSearchFilled
          size={17}
          color="rgba(255, 255, 255, 0.5)"
          style={{
            position: 'absolute',
            left: '18px',
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
          }}
        />
        <input
          type="text"
          placeholder={hint}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          enterKeyHint="search"
          aria-label={hint}
          className="w-full text-white outline-none bg-white/[0.08] focus:bg-white/[0.12] focus:shadow-[inset_0_0_0_1px_rgba(255,255,255,0.16)] placeholder:text-white/45 transition-all duration-200 ease-out"
          style={{
            height: '48px',
            borderRadius: '9999px',
            border: 'none',
            padding: '0 52px 0 48px',
            fontSize: '15px',
            fontWeight: 500,
            fontFamily: '"Public Sans", sans-serif',
          }}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange?.('')}
            aria-label="Limpiar búsqueda"
            className="absolute flex items-center justify-center w-10 h-10 rounded-full border-none bg-transparent cursor-pointer touch-manipulation [@media(hover:hover)]:hover:bg-white/[0.08] transition-colors duration-200"
            style={{
              right: '4px',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            <span
              className="flex items-center justify-center w-6 h-6 rounded-full"
              style={{ backgroundColor: 'rgba(255, 255, 255, 0.09)' }}
            >
              <IconX size={13} color="rgba(255, 255, 255, 0.7)" stroke={2.5} />
            </span>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="relative" style={{ height: '36px' }}>
      <input
        type="text"
        placeholder={hint}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="text-white outline-none"
        style={{
          width: 'min(300px, 30vw)',
          height: '36px',
          borderRadius: '9999px',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          border: 'none',
          padding: '0 44px 0 16px',
          fontSize: '14px',
          fontWeight: 500,
          fontFamily: '"Public Sans", sans-serif',
        }}
      />
      <button
        type="button"
        className="flex items-center justify-center"
        style={{
          position: 'absolute',
          right: '4px',
          top: '4px',
          width: '28px',
          height: '28px',
          borderRadius: '9999px',
          backgroundColor: '#034EA2',
          border: 'none',
          cursor: 'pointer',
        }}
      >
        <IconSearch size={15} color="#fff" />
      </button>
    </div>
  );
}
